<template>
  <el-container  style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 3%;">
        <el-row :span="2" style="margin-top: 30px;">

            <el-row :span="2" style="margin-top: 30px;">
                位置名称:<el-input v-model="name" style="width: 150px;" placeholder="请输入位置名称"></el-input>
            </el-row>
            <el-row :span="2" style="margin-top: 30px;">
                位置坐标:<el-input v-model="zuobiao" style="width: 150px;" placeholder="请输入位置坐标"></el-input>
            </el-row>

            <el-row :span="2" style="margin-top: 30px;">
                位置标签:<el-input v-model="biaoqian" style="width: 150px;" placeholder="请输入位置标签"></el-input>
            </el-row>


            <el-row :span="2" style="margin-top: 30px;">
                <el-button type="primary" style="background-color: #409eff;" @click="add()" round>添加</el-button>
            </el-row>
        </el-row>
        <el-row :span="2" style="margin-top: 30px;">
            <el-input v-model="seachName" style="width: 150px;" placeholder="请输入名称"></el-input>

            <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
        </el-row>

        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
            <el-table-column

              width="300"
              label="位置名称"
               >
               <template slot-scope="scope">
                   <div @click="dischange(scope.row.name,scope.row.id,1)">{{scope.row.name}}</div>
               </template>
            </el-table-column>
            <el-table-column
            
              width="300"
              label="地址"
               >
               <template slot-scope="scope">
                   <div @click="dischange(scope.row.weizhi,scope.row.id,4)">{{scope.row.weizhi}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="200"
              label="位置坐标"
               >
               <template slot-scope="scope">
                 <div @click="dischange(scope.row.zuobiao,scope.row.id,2)">{{scope.row.zuobiao}}</div>
               </template>
            </el-table-column>

            <el-table-column

              width="400"
              label="位置标签"
               >
               <template slot-scope="scope">
                   <div @click="dischange(scope.row.biaoqian,scope.row.id,3)">{{scope.row.biaoqian}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="600"
              label="标签"
               >
               <template slot-scope="scope">
                 <el-row>
                   <span v-for="(item,index) in scope.row.lables"><span v-if="index > 0" style="font-size: 22px;font-weight: bold;">|</span>{{item}}</span>
                 </el-row>

               </template>
            </el-table-column>
            <el-table-column

              width="200"
              label="操作"
               >
               <template slot-scope="scope">
                 <el-row>
                   <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="del(scope.row.id,scope.$index)">删除</el-col>

                 </el-row>
               </template>
            </el-table-column>


            </el-table>
          </template>
          <div class="page">
          	<el-pagination
          	  @size-change="loadList()"
          	  @current-change="loadList()"
          	  :current-page.sync="page"
          	  :page-size="15"
          	  background
          	  layout="total,prev, pager, next, jumper"
          	  :total="count">
          	</el-pagination>
          </div>
        </el-row>






    </el-row>
    <el-dialog
        title="修改"
        :visible.sync="disDialogVisible"
        width="30%"
        center>
        <input type="text" class="searchT" v-model="names"/>
        <span slot="footer" class="dialog-footer">
      	<el-button @click="disDialogVisible = false">取 消</el-button>
      	<el-button type="primary" @click="dodisChange()">确 定</el-button>
        </span>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
  export default {
    data() {
       return {
         page:1,
         count:0,
         list:[],
         seachName:'',
         name:'',
         zuobiao:'',
         biaoqian:'',
         disDialogVisible:false,


      }
    },
  directives: {
    },
    created() {

      this.loadList();

    },

  methods:{
    dischange(name,id,t){
      this.t = t;
      this.changeId = id
      this.names = name
      this.disDialogVisible = true
    },
    dodisChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.changeId,
          name:this.names,
          t:this.t
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/dingweiChanges'
      })
      .then(res=>{
        console.log(res.data.code)
        if(res.data.code == 200){
          this.disDialogVisible = false
          this.loadList()
        }else{
          this.msg('名称重复','error');
          this.disDialogVisible = false

        }



      })
      .catch(err=>{

      });
    },
    ceshi(index){
      this.imageId = index
    },
    del(id,index){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      if(this.delId == ''){
         return false
      }
      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/dingweiDel'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
           this.loadList();
      	}else{

      	}

      })
      .catch(err=>{

      });
    },

    seach(){
      this.loadList();
    },


    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page,

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/dingweilist'
      })
      .then(res=>{

        this.list = res.data.list;
        this.list.forEach(function(item, index) {
              item['img_s'] = 0;
              item['lables'] = item['biaoqian'].split(',');
        })
        this.count = res.data.count;


      })
      .catch(err=>{

      });
    },
    add(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.name == ''){
        this.msg('请填写名称','error')
        return false
      }
      if(this.wangzhi == ''){
        this.msg('请填写网址','error')
        return false
      }


      axiosInstance({
      	method:'post',
      	url:'http://y31p.yoooooo.com/index.php/index/data/dingweiAdd',
      	params:{
      		name:this.name,
          zuobiao:this.zuobiao,
          biaoqian:this.biaoqian,

      	}
      })
      .then(res=>{

        this.loadList()
      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/fxdingwei.vue